const isProduction = process.env.NODE_ENV === "production";

export const getChainlitUrl = (): string => {
  let url = "";
  if (process.env.REACT_APP_CHAINLIT_URL) {
    url = process.env.REACT_APP_CHAINLIT_URL;
  } else if (isProduction) {
    url = "about:blank";
  } else {
    url = "http://localhost:8000/chainlit/";
  }

  // LINE Browser Detection: Force external browser to support Google OAuth
  // LINE In-App Browser blocks Google OAuth, so we use ?openExternalBrowser=1 to open system browser
  if (
    typeof navigator !== "undefined" &&
    navigator.userAgent &&
    /Line\//i.test(navigator.userAgent) &&
    url &&
    url !== "about:blank"
  ) {
    if (!url.includes("openExternalBrowser=1")) {
      const separator = url.includes("?") ? "&" : "?";
      url = `${url}${separator}openExternalBrowser=1`;
    }
  }

  return url;
};

export const getChainlitIframeUrl = (): string => {
  if (process.env.REACT_APP_CHAINLIT_IFRAME_URL) {
    return process.env.REACT_APP_CHAINLIT_IFRAME_URL;
  }
  if (process.env.REACT_APP_CHAINLIT_URL) {
    return process.env.REACT_APP_CHAINLIT_URL;
  }
  if (isProduction) {
    return "about:blank";
  }
  return "http://localhost:8000/chainlit/";
};

export const getChainlitApiUrl = (): string => {
  if (process.env.REACT_APP_CHAINLIT_API_URL) {
    return process.env.REACT_APP_CHAINLIT_API_URL;
  }
  if (process.env.REACT_APP_CHAINLIT_URL) {
    return process.env.REACT_APP_CHAINLIT_URL;
  }
  if (isProduction) {
    return "";
  }
  return "http://localhost:8001";
};
